import React, { Component } from "react";
import "../../assets/web/assets/mobirise-icons2/mobirise2.css";
import "../../assets/web/assets/mobirise-icons/mobirise-icons.css";
import "../../assets/tether/tether.min.css";
import "../../assets/bootstrap/css/bootstrap.min.css";
import "../../assets/bootstrap/css/bootstrap-grid.min.css";
import "../../assets/bootstrap/css/bootstrap-reboot.min.css";
import "../../assets/dropdown/css/style.css";
import "../../assets/socicon/css/styles.css";
import "../../assets/theme/css/style.css";
import "../../assets/mobirise/css/mbr-additional.css";
import { Navbar, Nav } from "react-bootstrap";
import { Form, Button } from "antd";
import { toast } from "react-toastify";
import { signUp, signInAnonymously } from "../../store/actions/authActions";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import logo from "../../assets/images/logowhiterecmin.png";
import {
  addressValidaton,
  bankaccoutValidation,
  businessnameValidation,
  emailValidation,
  fullnameValidation,
  passwordValidation,
  phonenumberValidation,
} from "../../functions/utils";
import { GetRegionsForBusiness } from "../../store/actions/regionActions";
import Loading from "../widgets/Loading";

class BusinessRegistrationPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      business_name: "",
      business_address: "",
      business_email: "",
      business_phone: "",
      business_phone_2: "",
      region: "",
      bank_name: "",
      bank_account: "",
      rep_name: "",
      user_email: "",
      password: "",
      confirm_password: "",
      password_error: false,
      businessnameError: "",
      repnameError: "",
      repemailError: "",
      businessemailError: "",
      phoneError: "",
      secondaryphoneError: "",
      addressError: "",
      bankaccountError: "",
      passwordError: "",
      startregionloading: false,
      specifyRegion: false,
      selectedRegionObj: null,
      terms: false,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    document.title = "Register";
    if (this.props.auth.uid) {
      this.props.getRegions();
      this.setState({
        startregionloading: true,
      });
    } else {
      this.props.signInAnonymously();
    }
  }

  componentDidUpdate(prev, prevstate) {
    if (prev.auth.uid === null && this.props.auth.uid !== null) {
      this.props.signInAnonymously();
    } else if (
      this.props.auth.uid !== null &&
      this.props.auth.uid !== prev.auth.uid &&
      this.props.region.regions.length === 0
    ) {
      this.props.getRegions();
      this.setState({
        startregionloading: true,
      });
    } else if (!this.props.region.loading && prev.region.loading) {
      if (this.props.region.regions.length > 0) {
        this.setState({
          region: this.props.region.regions[0].id,
          selectedRegionObj: this.props.region.regions[0],
          specifyRegion: true,
        });
      } else {
        toast.error(
          "Registration is not avaialable, Please refresh the page or contact us"
        );
      }
    }
  }

  onFinish = () => {
    if (this.state.terms) {
      var anyerror = false;
      const businessnameError = businessnameValidation(
        this.state.business_name
      );
      if (businessnameError !== "") {
        anyerror = true;
        this.setState({
          businessnameError: businessnameError,
        });
      }

      const repnameError = fullnameValidation(this.state.rep_name);
      if (repnameError !== "") {
        anyerror = true;
        this.setState({
          repnameError: repnameError,
        });
      }
      const repemailError = emailValidation(this.state.user_email);
      if (repemailError !== "") {
        anyerror = true;
        this.setState({
          repemailError: repemailError,
        });
      }

      const businessemailError = emailValidation(this.state.business_email);
      if (businessemailError !== "") {
        anyerror = true;
        this.setState({
          businessemailError: businessemailError,
        });
      }

      const phoneError = phonenumberValidation(this.state.business_phone);
      if (phoneError !== "") {
        anyerror = true;
        this.setState({
          phoneError: phoneError,
        });
      }

      if (this.state.business_phone !== this.state.business_phone_2) {
        if (this.state.business_phone_2.length !== 0) {
          const secondaryphoneError = phonenumberValidation(
            this.state.business_phone_2
          );
          if (secondaryphoneError !== "") {
            anyerror = true;
            this.setState({
              secondaryphoneError: secondaryphoneError,
            });
          }
        }
      } else {
        anyerror = true;
        this.setState({
          secondaryphoneError: "Phone Numbers can't be Identical",
        });
      }

      const addressError = addressValidaton(this.state.business_address);
      if (addressError !== "") {
        anyerror = true;
        this.setState({
          addressError: addressError,
        });
      }

      if (this.state.bank_account.length !== 0) {
        const bankaccountError = bankaccoutValidation(this.state.bank_account);
        if (bankaccountError !== "") {
          anyerror = true;
          this.setState({
            bankaccountError: bankaccountError,
          });
        }
      }

      const passwordError = passwordValidation(this.state.password);
      if (passwordError !== "") {
        anyerror = true;
        this.setState({
          passwordError: passwordError,
        });
      }

      if (this.state.password === this.state.confirm_password) {
        this.setState({
          password_error: false,
        });
        const data = this.state;
        if (!anyerror) {
          this.props.signUp(data);
        } else {
          toast.error(
            "You have some errors on your inputs.\nPlease follow and apply the corrections."
          );
        }
      } else {
        this.setState({
          password_error: true,
        });
      }
    } else {
      window.alert("Please Check our Terms & Conditions!");
    }
  };

  onFinishFailed = (errorInfo) => {
    toast.error("Incorrect information, please check the form again.");
  };

  handleChange(event) {
    try {
      switch (event.target.id) {
        case "namefield":
          this.setState({
            business_name: event.target.value,
          });
          if (this.state.businessnameError !== "") {
            const businessnameError = businessnameValidation(
              event.target.value
            );
            this.setState({
              businessnameError: businessnameError,
            });
          }
          break;
        case "repnamefield":
          this.setState({
            rep_name: event.target.value,
          });
          if (this.state.repnameError !== "") {
            const repnameError = fullnameValidation(event.target.value);
            this.setState({
              repnameError: repnameError,
            });
          }
          break;
        case "emailfield":
          this.setState({
            business_email: event.target.value,
          });
          if (this.state.businessemailError !== "") {
            const businessemailError = emailValidation(event.target.value);
            this.setState({
              businessemailError: businessemailError,
            });
          }
          break;
        case "regionfield":
          this.setState({
            region: event.target.value,
            selectedRegionObj: this.props.region.regions.filter(function (
              objr
            ) {
              return objr.id === event.target.value;
            }).length,
            specifyRegion: true,
          });
          break;
        case "phonefield":
          this.setState({
            business_phone: event.target.value,
          });
          if (this.state.phoneError !== "") {
            const phoneError = phonenumberValidation(event.target.value);
            this.setState({
              phoneError: phoneError,
            });
          }
          break;
        case "altphonefield":
          this.setState({
            business_phone_2: event.target.value,
          });
          if (this.state.secondaryphoneError !== "") {
            const secondaryphoneError = phonenumberValidation(
              event.target.value
            );
            this.setState({
              secondaryphoneError: secondaryphoneError,
            });
          }
          break;
        case "locationfield":
          this.setState({
            business_address: event.target.value,
          });
          break;
        case "banknamefield":
          this.setState({
            bank_name: event.target.value,
          });
          break;
        case "bankaccountfield":
          this.setState({
            bank_account: event.target.value,
          });
          if (this.state.bankaccountError !== "") {
            const bankaccountError = bankaccoutValidation(event.target.value);
            this.setState({
              bankaccountError: bankaccountError,
            });
          }
          break;
        case "repemailfield":
          this.setState({
            user_email: event.target.value,
          });
          if (this.state.repemailError !== "") {
            const repemailError = emailValidation(event.target.value);
            this.setState({
              repemailError: repemailError,
            });
          }
          break;
        case "passwordfield":
          this.setState({
            password: event.target.value,
          });
          if (this.state.passwordError !== "") {
            const passwordError = passwordValidation(event.target.value);
            this.setState({
              passwordError: passwordError,
            });
          }
          break;
        case "cpasswordfield":
          this.setState({
            confirm_password: event.target.value,
          });
          break;

        case "termsfield":
          this.setState({
            terms: !this.state.terms,
          });
          break;
        default:
          break;
      }
      if (this.state.password === this.state.confirm_password) {
        this.setState({
          password_error: false,
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  render() {
    if (!this.props.auth.uid || this.props.auth.isAnonymous) {
      if (this.state.specifyRegion && !this.props.authprofile.loading) {
        return (
          <div>
            <section
              className="menu menu2 cid-smIpILaFmX"
              once="menu"
              id="menu2-0"
            >
              <Navbar
                collapseOnSelect
                expand="lg"
                className="navbar navbar-dropdown navbar-fixed-top navbar-expand-lg"
                style={{ backgroundColor: "rgba(98, 98, 98, 0.5)" }}
              >
                <div className="container-fluid">
                  <Navbar.Brand className="navbar-brand" href="#home">
                    <span className="navbar-logo">
                      <a href="/">
                        <img
                          src={logo}
                          alt="MassTaxi"
                          title=""
                          style={{ height: "2rem" }}
                        />
                      </a>
                    </span>
                  </Navbar.Brand>
                  {/* <Navbar.Toggle aria-controls="responsive-navbar-nav" /> */}
                  <Navbar.Toggle
                    className="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarSupportedContent"
                    aria-controls="navbarNavAltMarkup"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <div className="hamburger">
                      <span />
                      <span />
                      <span />
                      <span />
                    </div>
                  </Navbar.Toggle>
                  <Navbar.Collapse
                    className="collapse navbar-collapse"
                    id="navbarSupportedContent"
                  >
                    <Nav className="navbar-nav nav-dropdown nav-right">
                      <Nav.Link
                        className="nav-link link text-white text-primary display-4"
                        href="/"
                      >
                        Home
                      </Nav.Link>
                      <a
                        className="btn btn-primary display-4"
                        href="/business_login"
                      >
                        Login
                      </a>
                    </Nav>
                  </Navbar.Collapse>
                </div>
              </Navbar>
            </section>

            <section className="region3 cid-ssQWqIKWhT" id="region3-y">
              <div
                className="mbr-overlay"
                style={{ opacity: " 0.6", backgroundColor: "rgb(0, 0, 0)" }}
              />
              <div className="container">
                <div className="row justify-content-center">
                  <div className="card col-12 col-lg-10">
                    <div className="card-wrapper">
                      <div className="card-box align-center">
                        <h4 className="card-title mbr-fonts-style align-center mb-4 display-2">
                          <strong>Expand Your Reach!</strong>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="form5 cid-ssQVVQ31b6" id="form5-x">
              <div className="container">
                <div className="mbr-section-head">
                  <h3 className="mbr-section-title mbr-fonts-style align-center mb-0 display-2">
                    <strong>Register Your Company</strong>
                  </h3>
                  <h4 className="mbr-section-title mbr-fonts-style align-center mb-0 display-5">
                    <br />
                    <a
                      className="btn btn-primary display-4"
                      href="/business_login"
                    >
                      Login
                    </a>
                    If you have a bussiness account
                  </h4>
                </div>
                <div className="row justify-content-center mt-4">
                  <div
                    className="col-lg-8 mx-auto mbr-form"
                    data-form-type="formoid"
                  >
                    <Form
                      onFinish={this.onFinish}
                      onFinishFailed={this.onFinishFailed}
                      className="mbr-form form-with-styler"
                      data-form-title="Form Name"
                    >
                      <div className="dragArea row">
                        <div className="col-12 form-group" data-for="name">
                          <label
                            for="namefield"
                            className="form-control-label mbr-fonts-style display-7"
                          >
                            Business Name*
                          </label>
                          <input
                            type="text"
                            name="name"
                            maxLength="40"
                            minLength="2"
                            placeholder="Eg: Abebe Constructions"
                            required
                            data-form-field="name"
                            className="form-control"
                            value={this.state.business_name}
                            onChange={this.handleChange}
                            id="namefield"
                          />
                          <small className="errorHint">
                            <i className="formerror fa fa-asterisk"></i>
                            <p className="errorRed">
                              {this.state.businessnameError}
                            </p>
                          </small>
                        </div>

                        <div className="col-12 form-group">
                          <label className="form-control-label mbr-fonts-style display-7">
                            Representative Name*
                          </label>
                          <input
                            type="text"
                            maxLength="30"
                            minLength="2"
                            name="repname"
                            placeholder="Eg: Abel Bekele"
                            required
                            className="form-control"
                            value={this.state.rep_name}
                            onChange={this.handleChange}
                            id="repnamefield"
                          />
                          <small className="errorHint">
                            <i className="formerror fa fa-asterisk"></i>
                            <p className="errorRed">
                              {this.state.repnameError}
                            </p>
                          </small>
                        </div>

                        <div className="col-lg-6 form-group" data-for="email">
                          <label
                            for="emailfield"
                            className="form-control-label mbr-fonts-style display-7"
                          >
                            Business Email*
                          </label>
                          <input
                            type="email"
                            name="email"
                            maxLength="50"
                            minLength="4"
                            placeholder="Eg: info@abebeconstructions.com"
                            required
                            data-form-field="email"
                            className="form-control"
                            value={this.state.business_email}
                            onChange={this.handleChange}
                            id="emailfield"
                          />
                          <small className="errorHint">
                            <i className="formerror fa fa-asterisk"></i>
                            <p className="errorRed">
                              {this.state.businessemailError}
                            </p>
                          </small>
                        </div>

                        <div
                          className="col-lg-6 form-group regionfield"
                          data-for="region"
                        >
                          <label
                            for="regionfield"
                            className="form-control-label mbr-fonts-style display-7"
                          >
                            Region*
                          </label>
                          <select
                            id="regionfield"
                            name="region"
                            className="form-control display-7"
                            value={this.state.region}
                            onChange={this.handleChange}
                            required
                          >
                            {this.props.region.regions.map((reg) => (
                              <option value={reg.id}>{reg.name}</option>
                            ))}
                          </select>
                        </div>
                        <div className="col-lg-6 form-group" data-for="phone">
                          <label
                            for="phonefield"
                            className="form-control-label mbr-fonts-style display-7"
                          >
                            Phone*
                          </label>
                          <input
                            type="tel"
                            name="phone"
                            maxLength="13"
                            placeholder="Eg: +251115112233"
                            data-form-field="phone"
                            required
                            className="form-control"
                            value={this.state.business_phone}
                            onChange={this.handleChange}
                            id="phonefield"
                          />
                          <small className="errorHint">
                            <i className="formerror fa fa-asterisk"></i>
                            <p className="errorRed">{this.state.phoneError}</p>
                          </small>
                        </div>
                        <div
                          className="col-lg-6 form-group"
                          data-for="altphone"
                        >
                          <label
                            for="altphonefield"
                            className="form-control-label mbr-fonts-style display-7"
                          >
                            Secondary Phone (Optional)
                          </label>
                          <input
                            type="tel"
                            name="altphone"
                            maxLength="13"
                            placeholder="Eg: +251923112233"
                            data-form-field="altphone"
                            className="form-control"
                            value={this.state.business_phone_2}
                            onChange={this.handleChange}
                            id="altphonefield"
                          />
                          <small className="errorHint">
                            <i className="formerror fa fa-asterisk"></i>
                            <p className="errorRed">
                              {this.state.secondaryphoneError}
                            </p>
                          </small>
                        </div>
                        <div className="col-12 form-group" data-for="location">
                          <label
                            for="locationfield"
                            className="form-control-label mbr-fonts-style display-7"
                          >
                            Business Address*
                          </label>
                          <input
                            type="text"
                            name="location"
                            maxLength="75"
                            minLength="5"
                            placeholder="Eg: NSL W12, in-front of CBE, Addis Ababa"
                            data-form-field="location"
                            className="form-control"
                            required
                            value={this.state.business_address}
                            onChange={this.handleChange}
                            id="locationfield"
                          />
                          <small className="errorHint">
                            <i className="formerror fa fa-asterisk"></i>
                            <p className="errorRed">
                              {this.state.addressError}
                            </p>
                          </small>
                        </div>

                        <div
                          className="col-lg-6 form-group regionfield"
                          data-for="region"
                        >
                          <label
                            for="banknamefield"
                            className="form-control-label mbr-fonts-style display-7"
                          >
                            Business Bank Name (Optional)
                          </label>
                          <input
                            type="text"
                            name="bankname"
                            maxLength="50"
                            minLength="4"
                            placeholder="Eg: Commercial Bank of Ethiopia"
                            data-form-field="bankname"
                            className="form-control"
                            value={this.state.bank_name}
                            onChange={this.handleChange}
                            id="banknamefield"
                          />
                          {/* <small className="errorHint">
                            <i className="formerror fa fa-asterisk"></i>
                            <p className="errorRed">{this.state.repemailError}</p>
                          </small> */}
                          {/* <select
                            id="banknamefield"
                            name="bankname"
                            className="form-control display-7"
                            value={this.state.bank_name}
                            onChange={this.handleChange}
                            required
                          >
                            <option value="Abay Bank">Abay Bank</option>
                            <option value="Abyssinia Bank">
                              Abyssinia Bank
                            </option>
                            <option value="Awash Bank">Awash Bank</option>
                            <option value="Commercial Bank of Ethiopia">
                              Commercial Bank of Ethiopia
                            </option>
                            <option value="Dashen Bank">Dashen Bank</option>
                            <option value="Hibret Bank">Hibret Bank</option>
                            <option value="Nib Bank">Nib Bank</option>
                            <option value="Lion Bank">Lion Bank</option>
                            <option value="Wegagen Bank">Wegagen Bank</option>
                            <option value="Zemen Bank">Zemen Bank</option>
                          </select> */}
                        </div>

                        <div
                          className="col-lg-6 form-group"
                          data-for="location"
                        >
                          <label
                            for="bankaccountfield"
                            className="form-control-label mbr-fonts-style display-7"
                          >
                            Business Bank Account (Optional)
                          </label>
                          <input
                            type="text"
                            name="bank_account"
                            maxLength="18"
                            minLength="4"
                            placeholder="Eg: 1000100123432"
                            data-form-field="bank_account"
                            className="form-control"
                            value={this.state.bank_account}
                            onChange={this.handleChange}
                            id="bankaccountfield"
                          />
                          <small className="errorHint">
                            <i className="formerror fa fa-asterisk"></i>
                            <p className="errorRed">
                              {this.state.bankaccountError}
                            </p>
                          </small>
                        </div>

                        <div className="col-lg-12 form-group" data-for="email">
                          <label
                            for="repemailfield"
                            className="form-control-label mbr-fonts-style display-7"
                          >
                            Representative Email*
                          </label>
                          <input
                            type="email"
                            name="repemail"
                            maxLength="50"
                            minLength="4"
                            placeholder="Eg: info@abebeconstructions.com"
                            required
                            data-form-field="email"
                            className="form-control"
                            value={this.state.user_email}
                            onChange={this.handleChange}
                            id="repemailfield"
                          />
                          <small className="errorHint">
                            <i className="formerror fa fa-asterisk"></i>
                            <p className="errorRed">
                              {this.state.repemailError}
                            </p>
                          </small>
                        </div>
                        <div
                          className="col-lg-6 form-group"
                          data-for="password"
                        >
                          <label
                            for="passwordfield"
                            className="form-control-label mbr-fonts-style display-7"
                          >
                            Password*
                          </label>
                          <input
                            type="password"
                            name="password"
                            maxLength="25"
                            minLength="8"
                            data-form-field="password"
                            className="form-control"
                            required
                            value={this.state.password}
                            onChange={this.handleChange}
                            id="passwordfield"
                          />
                          <small className="errorHint">
                            <i className="formerror fa fa-asterisk"></i>
                            <p className="errorRed">
                              {this.state.passwordError}
                            </p>
                          </small>
                        </div>
                        <div
                          className="col-lg-6 form-group"
                          data-for="cpassword"
                        >
                          <label
                            for="cpasswordfield"
                            className="form-control-label mbr-fonts-style display-7"
                          >
                            Confirm Password*
                          </label>
                          <input
                            type="password"
                            name="cpassword"
                            maxLength="25"
                            minLength="8"
                            data-form-field="cpassword"
                            className="form-control"
                            required
                            value={this.state.confirm_password}
                            onChange={this.handleChange}
                            id="cpasswordfield"
                          />
                        </div>
                        {this.state.password_error ? (
                          <div className="col-lg-6 form-group">
                            <h4
                              className="mbr-section-title mbr-fonts-style align-left mb-0 display-7"
                              style={{ color: "red" }}
                            >
                              Passwords don't match, please try again
                            </h4>
                          </div>
                        ) : (
                          <span />
                        )}
                        <div className="col-lg-12 form-group">
                          <div className="tacbox">
                            <input
                              id="termsfield"
                              required
                              type="checkbox"
                              value={this.state.terms}
                              onChange={this.handleChange}
                            />
                            <label for="checkbox">
                              {" "}
                              <h4 className="mbr-section-title mbr-fonts-style align-left mb-0 display-7">
                                I agree to these{" "}
                                <a href="/business_terms" target="_blank">
                                  Terms and Conditions
                                </a>
                                .
                              </h4>
                            </label>
                          </div>
                        </div>

                        <div
                          className="col-lg-12 col-md-12 col-sm-12 align-center mbr-section-btn"
                          id="client_register_form_register_btn_div"
                        >
                          <Button
                            type="primary"
                            className="btn btn-black display-4"
                            htmlType="submit"
                          >
                            Register
                          </Button>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </section>
            <section
              className="footer3 cid-smIvGalAcO"
              once="footers"
              id="footer3-1u"
            >
              <div className="container">
                <div className="media-container-row align-center mbr-white">
                  <div className="row row-links">
                    <ul className="foot-menu">
                      <li className="foot-menu-item mbr-fonts-style display-7">
                        <a href="/" className="text-primary">
                          Home
                        </a>
                      </li>
                      <li className="foot-menu-item mbr-fonts-style display-7">
                        <a href="/contacts" className="text-primary">
                          Contact Us
                        </a>
                      </li>
                      <li className="foot-menu-item mbr-fonts-style display-7">
                        <a href="/driver" className="text-primary">
                          Driver
                        </a>
                      </li>
                      <li className="foot-menu-item mbr-fonts-style display-7">
                        <a href="/business_login" className="text-primary">
                          Login
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="row social-row">
                    <div className="social-list align-right pb-2">
                      <div className="soc-item">
                        <a
                          href="https://www.facebook.com/masstaxiads"
                          rel="noreferrer"
                          target="_blank"
                        >
                          <span className="socicon-facebook socicon mbr-iconfont mbr-iconfont-social" />
                        </a>
                      </div>
                      <div className="soc-item">
                        <a
                          href="https://www.youtube.com/channel/UCsBTZqPsr-ceq197Fz1gYcw"
                          rel="noreferrer"
                          target="_blank"
                        >
                          <span className="socicon-youtube socicon mbr-iconfont mbr-iconfont-social" />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="row row-copirayt">
                    <p className="mbr-text mb-0 mbr-fonts-style mbr-white align-center display-7">
                      © MassTaxi 2021. Service Provided by DAST ICT Solutions
                      PLC. All Rights Reserved.
                    </p>
                  </div>
                </div>
              </div>
            </section>
          </div>
        );
      } else {
        return (
          <div className="row justify-content-center fullloading">
            <div className="col-lg-8 form-group">
              <Loading />
            </div>
          </div>
        );
      }
    }
    return <Redirect to="/" />;
  }
}
const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    region: state.region,
    authprofile: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signUp: (profile) => dispatch(signUp(profile)),
    getRegions: () => dispatch(GetRegionsForBusiness()),
    signInAnonymously: () => dispatch(signInAnonymously()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BusinessRegistrationPage);
